// src/contexts/ApiResponseHandlerContext.tsx
import React, { createContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

export enum ApiResponseHandlerType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

interface ApiResponseHandlerContextType {
  showResponseNotification: (message: string, type: ApiResponseHandlerType) => void;
}

export const ApiResponseHandlerContext = createContext<ApiResponseHandlerContextType | undefined>(undefined);

export const ApiResponseHandlerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState<ApiResponseHandlerType>(ApiResponseHandlerType.SUCCESS);

  const showResponseNotification = (message: string, type: ApiResponseHandlerType) => {
    setMessage(message);
    setType(type);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <ApiResponseHandlerContext.Provider value={{ showResponseNotification }}>
      {children}
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert sx={{ width: '100%' }} onClose={handleClose} severity={type} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    </ApiResponseHandlerContext.Provider>
  );
};
